import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ConfigSectionComponent } from "./config-section.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { AngularMaterialModule } from "src/app/shared/material-module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MatExpansionModule } from "@angular/material/expansion";

@NgModule({
  declarations: [ConfigSectionComponent],
  imports: [
    BrowserModule, 
    CommonModule, 
    FormsModule, 
    ReactiveFormsModule, 
    AngularMaterialModule, 
    NgbModule, 
    MatExpansionModule
  ],
  exports: [ConfigSectionComponent],
})
export class ConfigSectionModule {}
